// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { EnumMapRule, EnumMapRuleT } from "./enum-map-rule";
import { FlagRule, FlagRuleT } from "./flag-rule";
import { IgnoreRule, IgnoreRuleT } from "./ignore-rule";
import { RecordRule, RecordRuleT } from "./record-rule";
import { TransformRule, TransformRuleT } from "./transform-rule";
import { ValuedRule, ValuedRuleT } from "./valued-rule";

export enum Rule {
  NONE = 0,
  IgnoreRule = 1,
  FlagRule = 2,
  ValuedRule = 3,
  EnumMapRule = 4,
  RecordRule = 5,
  TransformRule = 6,
}

export function unionToRule(
  type: Rule,
  accessor: (
    obj: EnumMapRule | FlagRule | IgnoreRule | RecordRule | TransformRule | ValuedRule,
  ) => EnumMapRule | FlagRule | IgnoreRule | RecordRule | TransformRule | ValuedRule | null,
): EnumMapRule | FlagRule | IgnoreRule | RecordRule | TransformRule | ValuedRule | null {
  switch (Rule[type]) {
    case "NONE":
      return null;
    case "IgnoreRule":
      return accessor(new IgnoreRule())! as IgnoreRule;
    case "FlagRule":
      return accessor(new FlagRule())! as FlagRule;
    case "ValuedRule":
      return accessor(new ValuedRule())! as ValuedRule;
    case "EnumMapRule":
      return accessor(new EnumMapRule())! as EnumMapRule;
    case "RecordRule":
      return accessor(new RecordRule())! as RecordRule;
    case "TransformRule":
      return accessor(new TransformRule())! as TransformRule;
    default:
      return null;
  }
}

export function unionListToRule(
  type: Rule,
  accessor: (
    index: number,
    obj: EnumMapRule | FlagRule | IgnoreRule | RecordRule | TransformRule | ValuedRule,
  ) => EnumMapRule | FlagRule | IgnoreRule | RecordRule | TransformRule | ValuedRule | null,
  index: number,
): EnumMapRule | FlagRule | IgnoreRule | RecordRule | TransformRule | ValuedRule | null {
  switch (Rule[type]) {
    case "NONE":
      return null;
    case "IgnoreRule":
      return accessor(index, new IgnoreRule())! as IgnoreRule;
    case "FlagRule":
      return accessor(index, new FlagRule())! as FlagRule;
    case "ValuedRule":
      return accessor(index, new ValuedRule())! as ValuedRule;
    case "EnumMapRule":
      return accessor(index, new EnumMapRule())! as EnumMapRule;
    case "RecordRule":
      return accessor(index, new RecordRule())! as RecordRule;
    case "TransformRule":
      return accessor(index, new TransformRule())! as TransformRule;
    default:
      return null;
  }
}

export type RuleT =
  | { type: "NONE"; value: null }
  | { type: "IgnoreRule"; value: IgnoreRuleT }
  | { type: "FlagRule"; value: FlagRuleT }
  | { type: "ValuedRule"; value: ValuedRuleT }
  | { type: "EnumMapRule"; value: EnumMapRuleT }
  | { type: "RecordRule"; value: RecordRuleT }
  | { type: "TransformRule"; value: TransformRuleT };
